import { Box } from '@mui/material'
import { makeStyles } from "@mui/styles";
import WifiIcon from '@mui/icons-material/Wifi';
import Wifi2BarIcon from '@mui/icons-material/Wifi2Bar';
import Wifi1BarIcon from '@mui/icons-material/Wifi1Bar';
import WifiOffIcon from '@mui/icons-material/WifiOff';
const useStyles = makeStyles((theme) => ({
  indicator: (props) => {
    return {
      color: 'white',
      [theme.breakpoints.down('md')]: {
        color: theme.palette.primary.main,
      }
    }
  },
}))
const SignalIcon = ({ ping }) => {
  const classes = useStyles(ping)

  if (ping < 100) {
    return <WifiIcon className={classes.indicator} />
  } else if (ping >= 100 && ping < 250) {
    return <Wifi2BarIcon className={classes.indicator} />
  } else if (ping >= 250 && ping < 500) {
    return <Wifi2BarIcon className={classes.indicator} />
  } else if (ping >= 500 && ping < 1000) {
    return <Wifi1BarIcon className={classes.indicator} />
  } else {
    return <WifiOffIcon className={classes.indicator} />
  }
}
export default function PingIndicator({ ping }) {
  return (
    <Box>
      <SignalIcon ping={ping} />
    </Box>
  )
}